// extracted by css-extract-rspack-plugin
export default {"resizing":"X8eTl","column":"Wi55k","footer":"X5Kev","preview":"fglsT"};